export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14244.1429e7f2.jpg";